import React from "react";
import circleSpinner from "../staticResources/logos/Ripple-1s-200px.svg";
export default function CircleSpinner({ width, height }: { height?: string; width?: string }) {
  const style = { width, height };
  return <img src={circleSpinner} {...style} alt="Spinner" />;
}
